module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "failureofjustice-kindleinterior-5-8-2016"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "tc-101"
    }
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "toc-body-text-261-0-filtered"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0005#toc-anchor-40"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text-261-0-filtered"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006#toc-anchor-41"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#toc-anchor"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0007#toc-anchor-43"
    }
  }, [_vm._v("THE PROWLER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0008#toc-anchor-1"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0008#toc-anchor-44"
    }
  }, [_vm._v("A CHILLING DISCOVERY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0009#toc-anchor-2"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0009#toc-anchor-45"
    }
  }, [_vm._v("AN OLD FAMILIAR FACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#toc-anchor-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0010#toc-anchor-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FBI’S KILLER PROFILE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#toc-anchor-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0011#toc-anchor-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HOG FARMER P.I.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012#toc-anchor-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0012#toc-anchor-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOANN’S SAGA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013#toc-anchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0013#toc-anchor-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BACK IN NEBRASKA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#toc-anchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0014#toc-anchor-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NON-SECRETOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#toc-anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0015#toc-anchor-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOSEPH’S TALE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#toc-anchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0016#toc-anchor-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INFORMANT REVISITED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#toc-anchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0017#toc-anchor-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALABAMA, HERE WE COME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#toc-anchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0018#toc-anchor-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLASS OF ICED TEA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#toc-anchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0019#toc-anchor-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SNITCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#toc-anchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0020#toc-anchor-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEBBIE’S DILEMMA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#toc-anchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0021#toc-anchor-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE POLYGRAPH TEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#toc-anchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0022#toc-anchor-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DETECTIVE WANTS OUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#toc-anchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0023#toc-anchor-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONVINCING KATHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#toc-anchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0024#toc-anchor-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ALL-SEEING EYE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#toc-anchor-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0025#toc-anchor-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOANN’S CONFESSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#toc-anchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0026#toc-anchor-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NO PLEA DEALS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#toc-anchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0027#toc-anchor-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OLD WEST COURTHOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#toc-anchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0028#toc-anchor-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APARTMENT UNIT 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#toc-anchor-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0029#toc-anchor-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE PILLOW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#toc-anchor-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0030#toc-anchor-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘THAT OLD WOMAN’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#toc-anchor-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0031#toc-anchor-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIFE OR DEATH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#toc-anchor-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0032#toc-anchor-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRIALS REMAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#toc-anchor-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0033#toc-anchor-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLIMMER OF HOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#toc-anchor-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0034#toc-anchor-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNEXPECTED TWIST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#toc-anchor-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0035#toc-anchor-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STARTING OVER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#toc-anchor-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0036#toc-anchor-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OLD SUSPECTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#toc-anchor-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0037#toc-anchor-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REVELATION TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#toc-anchor-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0038#toc-anchor-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WICKED LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#toc-anchor-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0039#toc-anchor-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEYOND ALL DOUBT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#toc-anchor-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0040#toc-anchor-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUBILATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#toc-anchor-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0041#toc-anchor-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTHOLES AHEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#toc-anchor-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0042#toc-anchor-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RITNOUR’S WRATH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#toc-anchor-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0043#toc-anchor-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BACK IN SOCIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#toc-anchor-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0044#toc-anchor-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TROUBLE AT TARRANT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#toc-anchor-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0045#toc-anchor-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIGHT BEHIND DARKNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#toc-anchor-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter1 sgc-2"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/part0046#toc-anchor-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LASTING TRIBUTE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text-261-0-filtered"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0047#toc-anchor-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-body-text-261-0-filtered"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_13"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0